import { globallyOnce } from '@epihub/core/src/fn/memoize';
import { ColorModule } from './ColorModule';
import type { Col, HexColor } from './const';
import { normalizeToHex } from './const';

export class Color {
  readonly hex: HexColor;

  get rgb() {
    return globallyOnce(this.hex.toLowerCase(), () => {
      return ColorModule.hexToRGB(this.hex);
    });
  }

  constructor(create: Col) {
    this.hex = normalizeToHex(create);
  }

  readonly rgba = (a: number) => {
    return `rgba(${this.rgb.r}, ${this.rgb.g}, ${this.rgb.b}, ${a})`;
  };

  toString() {
    return this.hex;
  }
}
